<script>
import AdvBaseControl from '@advisor/components/common/AdvBaseControl.vue';
import {PROP} from '@advisor/util/constants';

export default {
  name: 'AdvSwitch',
  extends: AdvBaseControl,
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {type: [Boolean, Number], default: false},
    // eslint-disable-next-line no-undefined
    appendIcon: {...PROP.STRING_TYPE, default: undefined},
    appendIconCb: {
      type: Function,
      required: false,
      default: null,
    },
    // eslint-disable-next-line no-undefined
    backgroundColor: {...PROP.STRING_TYPE, default: undefined},
    error: {...PROP.BOOLEAN_TYPE, default: false},
    errorCount: {
      // eslint-disable-next-line no-bitwise, vue/require-prop-type-constructor
      type: Number | String,
      required: false,
      default: 1,
    },
    errorMessages: {
      // eslint-disable-next-line no-bitwise, vue/require-prop-type-constructor
      type: String | Array,
      required: false,
      default() {
        return [];
      },
    },
    falseValue: {
      required: false,
      // eslint-disable-next-line no-undefined
      default: undefined,
    },
    height: {
      // eslint-disable-next-line no-bitwise, vue/require-prop-type-constructor
      type: Number | String,
      required: false,
      // eslint-disable-next-line no-undefined
      default: undefined,
    },
    hideDetails: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line no-undefined
    hint: {...PROP.STRING_TYPE, default: undefined},
    // eslint-disable-next-line no-undefined
    id: {...PROP.STRING_TYPE, default: undefined},
    inset: {type: Boolean, required: false},
    // eslint-disable-next-line no-undefined
    label: {...PROP.STRING_TYPE, default: undefined},
    messages: {
      // eslint-disable-next-line no-bitwise, vue/require-prop-type-constructor
      type: String | Array,
      required: false,
      default() {
        return [];
      },
    },
    multiple: {...PROP.BOOLEAN_TYPE, default: false},
    persistentHint: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line no-undefined
    prependIcon: {...PROP.STRING_TYPE, default: undefined},
    prependIconCb: {
      type: Function,
      required: false,
      default: null,
    },
    readonly: {...PROP.BOOLEAN_TYPE, default: false},
    disabled: {...PROP.BOOLEAN_TYPE, default: false},
    ripple: {...PROP.BOOLEAN_TYPE, default: true},
    rules: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    success: {...PROP.BOOLEAN_TYPE, default: false},
    successMessages: {
      // eslint-disable-next-line no-bitwise, vue/require-prop-type-constructor
      type: String | Array,
      required: false,
      default() {
        return [];
      },
    },
    trueValue: {
      required: false,
      // eslint-disable-next-line no-undefined
      default: undefined,
    },
    validateOnBlur: {...PROP.BOOLEAN_TYPE, default: false},
    valueComparator: {
      type: Function,
      required: false,
      default: null,
    },
  },
  methods: {
    onChange() {
      this.$emit('change', !this.value);
    },
  },
};
</script>

<template>
  <v-switch
    :id="id"
    data-test-id="onChange"
    :disabled="!isVisible(null, false) || disabled"
    :input-value="value"
    :color="color"
    :dark="dark"
    :light="light"
    :loading="loading"
    :append-icon="appendIcon"
    :append-icon-cb="appendIconCb"
    :background-color="backgroundColor"
    :error="error"
    :error-count="errorCount"
    :error-messages="errorMessages"
    :false-value="falseValue"
    :height="height"
    :hide-details="hideDetails"
    :hint="hint"
    :inset="inset"
    :label="label"
    :messages="messages"
    :multiple="multiple"
    :persistent-hint="persistentHint"
    :prepend-icon="prependIcon"
    :prepend-icon-cb="prependIconCb"
    :readonly="readonly"
    :ripple="ripple"
    :rules="rules"
    :success="success"
    :success-messages="successMessages"
    :true-value="trueValue"
    :validate-on-blur="validateOnBlur"
    :value-comparator="valueComparator"
    @change="onChange"
  >
    <template #label>
      <slot name="label" />
    </template>
  </v-switch>
</template>
